export class FormattingUtils {
  static replaceControlCharacters(text: string, replaceTo = '') {
    return text?.replace(/\s/g, replaceTo) ?? text;
  }

  static pluralize(count: number, noun: string, suffix: string = 's') {
    return `${noun}${count !== 1 ? suffix : ''}`;
  }

  static getValueTrimmed = (value: string, charLengthAllowed: number) => {
    return value?.length > charLengthAllowed ? value.slice(0, charLengthAllowed) + '...' : value;
  };

  static getTitleIfValueIsTrimmed = (value: string, charLengthAllowed: number) => {
    return value?.length > charLengthAllowed ? value : undefined;
  };
}
